import { useTranslation } from 'react-i18next';

export function useStepsCardController() {
  const { t } = useTranslation();

  const stepsTitle = t('charity.steps.title');

  return { stepsTitle };
}
